import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { AbstractGuard } from '../shared';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services';
import { Observable, of, from } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import * as _firebase from 'firebase/app';
const firebase = _firebase;

@Injectable({
  providedIn: 'root'
})
export class ComposeGuard implements CanActivate {
  constructor (
    private auth:AuthService,
    private abstractGaurd:AbstractGuard,
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const survey_id = next.params.survey_id || next.queryParams.survey_id;
    return this.abstractGaurd.canActivate(next, state).pipe(
      switchMap(bool=>{
        if (!bool || !this.checkAgainstScope()) {
          return this.auth.upgradeToken(survey_id, undefined, ['2íë']).pipe(map(()=>this.checkAgainstScope()));
        } else {
          return of(bool);
        } 
      }),
    );
  }
  checkAgainstScope() {
    const idTokenResult = this.auth._idTokenResult;
    return get(idTokenResult, 'claims.compose') ? true : false;
  }
}